import $ from 'jquery';

export default function smoothScrollModule() {
  const smoothScrollElement = $('.smooth-scroll');
  if (smoothScrollElement.length) {
    return import(/* webpackChunkName: "smooth-scroll" */ '../smoothScroll')
      .then(({ default: SmoothScroll }) => {
        const smoothScroll = new SmoothScroll();
        return smoothScroll;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
